import React from 'react'

import BirthdayBadgeIcon from '../../../static-assets/images/badges/birthday/birthday.svg'

import LoyaltyIcon1 from '../../../static-assets/images/badges/loyalty/loyalty-tier-1.svg'
import LoyaltyIcon2 from '../../../static-assets/images/badges/loyalty/loyalty-tier-2.svg'
import LoyaltyIcon3 from '../../../static-assets/images/badges/loyalty/loyalty-tier-3.svg'

import SecurityIcon1 from '../../../static-assets/images/badges/security/security-tier-1.svg'
import SecurityIcon2 from '../../../static-assets/images/badges/security/security-tier-2.svg'
import SecurityIcon3 from '../../../static-assets/images/badges/security/security-tier-3.svg'

import OnIcon from '../../../static-assets/images/badges/preferred/preferred-browser-on.svg'
import OffIcon from '../../../static-assets/images/badges/preferred/preferred-browser-off.svg'

export const BIRTHDAY_SCHEMA = {
  key: 'birthday',
  heading: {
    DEFAULT: `Happy Birthday Week`,
  },
  desc: {
    DEFAULT: `Celebrating you and another trip around the sun!`,
  },
  icon: {
    DEFAULT: (
      <BirthdayBadgeIcon
        data-testid="birthday-badge"
        title="Illustration: Mint green circular badge featuring a slice of triple layer pink birthday cake with frosting, sprinkles, and a lit candle ready for you to make a wish."
      />
    ),
  },
}

export const LOYALTY_SCHEMA = {
  key: 'loyalty',
  heading: {
    FALLBACK: 'Ally Go-Getter',
    TIER1: 'Ally Go-Getter',
    TIER2: 'Ally Achiever',
    TIER3: 'Ally Mogul',
  },
  desc: {
    FALLBACK: `You've unlocked a bright financial future with Ally.`,
    TIER1: `Working together since`,
    TIER2: `Working together since`,
    TIER3: `Working together since`,
  },
  icon: {
    FALLBACK: (
      <LoyaltyIcon1
        data-testid="fallback-loyalty-badge"
        title={`Illustration: Dark purple shield badge featuring a mint green backpack with pink accents and a lighter purple progress bar at the top showing you've taken a few steps toward being more security aware.`}
      />
    ),
    TIER1: (
      <LoyaltyIcon1
        data-testid="tier1-loyalty-badge"
        title={`Illustration: Dark purple shield badge featuring a mint green backpack with pink accents and a lighter purple progress bar at the top showing you've taken a few steps toward being more security aware.`}
      />
    ),
    TIER2: (
      <LoyaltyIcon2
        data-testid="tier2-loyalty-badge"
        title={`Illustration: Dark purple shield badge featuring a mint green open book with pink bookmark and a lighter purple progress bar at the top showing you've taken a few more steps toward being more security aware.`}
      />
    ),
    TIER3: (
      <LoyaltyIcon3
        data-testid="tier3-loyalty-badge"
        title="Illustration: Deep purple flag badge featuring a light purple crown with multicolored gemstones and three points topped with more gemstones to celebrate your 10+ years with Ally."
      />
    ),
  },
}

export const SECURITY_SCHEMA = {
  key: 'security',
  heading: {
    FALLBACK: 'Security Student',
    TIER1: 'Security Student',
    TIER2: 'Security Scholar',
    TIER3: 'Security Graduate',
  },
  desc: {
    FALLBACK: `You're on your way to security straight-A's.`,
    TIER1: `You're on your way to security straight-A's.`,
    TIER2: `You're almost on the honor roll!`,
    TIER3: `Boom! Great work.`,
  },
  icon: {
    FALLBACK: (
      <SecurityIcon1
        data-testid="security-badge"
        title={`Illustration: Dark purple shield badge featuring a mint green backpack with a handle, straps, side pocket and pink zippers and patch and a lighter purple progress bar at the top showing you've taken a few steps toward being more security aware.`}
      />
    ),
    TIER1: (
      <SecurityIcon1
        data-testid="tier1-security-badge"
        title={`Illustration: Dark purple shield badge featuring a mint green backpack with a handle, straps, side pocket and pink zippers and patch and a lighter purple progress bar at the top showing you've taken a few steps toward being more security aware.`}
      />
    ),
    TIER2: (
      <SecurityIcon2
        data-testid="tier2-security-badge"
        title={`Illustration: Dark purple shield badge featuring a mint green open book with pink bookmark and a lighter purple progress bar at the top showing you've taken a few more steps toward being more security aware.`}
      />
    ),
    TIER3: (
      <SecurityIcon3
        data-testid="tier3-security-badge"
        title={`Illustration: Dark purple shield badge featuring a mint green graduation cap with pink tassel and a lighter purple progress bar at the top showing you've completed all the steps to be more security aware.`}
      />
    ),
  },
}

export const BROWSER_SCHEMA = {
  key: 'browser',
  heading: {
    SUCCESS: `Lookin' Good!`,
    FAILURE: 'Level Up',
  },
  desc: {
    SUCCESS: `You're using an Ally-preferred browser.`,
    FAILURE: `for a security boost.`,
  },
  icon: {
    SUCCESS: (
      <OnIcon
        data-testid="preferred-browser-success-badge"
        title={`Illustration: Light purple hexagonal badge with a dark purple globe-like icon with gridlines and green dots to represent internet/browser security. A white checkmark on a green circle sits on the bottom left of the badge indicating you're using an Ally-preferred browser.`}
      />
    ),
    FAILURE: (
      <OffIcon
        data-testid="preferred-browser-failure-badge"
        title="Illustration: Light purple hexagonal badge with a dark purple globe-like icon with gridlines and red dots to represent internet/browser security. A white exclamation point on a red circle sits on the bottom left of the badge indicating you need to update your browser."
      />
    ),
  },
}
